import React, { useEffect, useRef, useState } from 'react';
import Graphic from "@arcgis/core/Graphic";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";
import MapNewProperty from '../../componets/MapNewProperty';
import * as XLSX from 'xlsx';
import { useNavigate } from "react-router-dom";
// PrimeReact Imports
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import "primereact/resources/themes/lara-light-indigo/theme.css"; // Theme
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Chart } from "react-google-charts";
import LayerControlPanel from '../../componets/LayerControlPanel';
import { Alert } from 'react-bootstrap';


const layersData = [
    "Administrative Boundaries",
    "Agriculture",
    "Climate",
    "Cooperative Societies",
    "Cultural",
    "Education",
    "Election",
    "Emergency Services",
    "Excise",
];


// === Sublayer Groups ===
const BASE_SERVICE_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

const ADMIN_BOUNDARIES_SUBLAYERS = [
    { id: 1, title: "MP State", visible: false },
    { id: 2, title: "MP Division", visible: false },
    { id: 3, title: "MP District", visible: false },
    { id: 94, title: "MP ULB", visible: false },
    { id: 95, title: "MP Ward", visible: false },
    { id: 5, title: "Municipal Area", visible: false },
    { id: 7, title: "Municipal Ward", visible: false },
];

const PROPERTY_SUBLAYERS = [
    { id: 14, title: "Property", visible: false },
    { id: 15, title: "Building Footprint", visible: false },
    { id: 16, title: "Builtup Area", visible: false },
    { id: 17, title: "Slum Area", visible: false },
    { id: 39, title: "Industrial Area", visible: false },
];

const GREEN_SPACE_SUBLAYERS = [
    { id: 30, title: "Agricultural Area", visible: false },
    { id: 32, title: "Forest", visible: false },
    { id: 33, title: "Vacant Lands", visible: false },
    { id: 34, title: "Waste Lands", visible: false },
    { id: 36, title: "Open Land", visible: false },
    { id: 38, title: "Playground", visible: false },
    { id: 41, title: "Plantation", visible: false },
    { id: 42, title: "Orchyard", visible: false },
    { id: 43, title: "Park", visible: false },
];
//  const BaseRoadMapURL  = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap//MapServer";
   
// const Road_SUBLAYERS = [
//     { id: 45, title: "Roads", visible: false },
// ]


const TRANSPORTATION_SUBLAYERS = [
    { id: 45, title: "Roads", visible: false },
    { id: 56, title: "Railway", visible: false },
    { id: 59, title: "Railway Station", visible: false },
    { id: 61, title: "Aircraft Road", visible: false },
    { id: 62, title: "Airport", visible: false },
    { id: 63, title: "Helipad", visible: false },
    { id: 64, title: "Busstand", visible: false },
];

const WATERBODIES_SUBLAYERS = [
    { id: 69, title: "Rivers", visible: false },
    { id: 70, title: "Drainage or Nala", visible: false },
    { id: 75, title: "Lake/Pond/Reservoir", visible: false },
];

const LANDMARKS_SUBLAYERS = [
    { id: 79, title: "Important Landmarks", visible: false },
];

const MASTER_PLAN_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer";

const MASTER_PLAN_SUBLAYERS = [
    { id: 1, title: "Planning Area", visible: false },
    { id: 2, title: "Master Plan Village Boundary", visible: false },
    { id: 3, title: "Master Plan", visible: false },
];

const SAMPDA_GUIDELINE_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sampda_guideline/MapServer";

const SAMPDA_GUIDELINE_SUBLAYERS = [
    { id: 1, title: "Sampda Guideline 2025_26", visible: false },
];

const WATER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer";

const WATER_SUBLAYERS = [
    { id: 1, title: "WTP", visible: false },
    { id: 2, title: "Intake Well", visible: false },
    { id: 3, title: "OHT", visible: false },
    { id: 4, title: "Junction", visible: false },
    { id: 5, title: "RWPM", visible: false },
    { id: 6, title: "CWPM", visible: false },
    { id: 7, title: "Distribution Line", visible: false },
];

const SEWER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer";

const SEWER_SUBLAYERS = [
    { id: 1, title: "STP", visible: false },
    { id: 2, title: "MPS", visible: false },
    { id: 3, title: "IPS", visible: false },
    { id: 4, title: "Manhole", visible: false },
    { id: 5, title: "Sewer Line", visible: false },
];

const ASSETS_URL1 = "https://urbangis.mp.gov.in/server/rest/services/temp_n/govt_assets_mis/MapServer";
const ASSETS_Central_SUBLAYERS = [
    { id: 2, title: "Central Govt Assets", visible: false },
    { id: 3, title: "State Govt Assets",   visible: false },
    { id: 4, title: "Municipal Govt Assets", visible: false}
];

const MPLanduse = "https://urbangis.mp.gov.in/server/rest/services/temp_n/mp_lulc_change/MapServer";
const MPLanduse_sublayer = [
    { id: 6, title: "Landuse 2022", visible: false },
    { id: 8, title: "Landuse 2024", visible: false },   
];

const StormWaterURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/stormwater_project_data/MapServer";
const StormWaterURL_sublayer = [
    { id: 1, title: "Storm Water Drainage Line", visible: false },    
];


const LandSuitabilityURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/land_suitability/MapServer";
const LandSuitabilityURL_sublayer = [
    { id: 2, title: "For Conservation", visible: false },
    { id: 3, title: "For Plantation", visible: false },

];
// === Layer Groups ===
const SBM_URL1 = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sbm_data/MapServer";
const SBM_SUBLAYERS = [
    { id: 1, title: "All Processing Plant", visible: false },
    { id: 11, title: "Bio Methanation", visible: false },
    { id: 12, title: "C&D Waste Processing Facility", visible: false },
    { id: 13, title: "Faecal Sludge Treatment Plant (FSTP)", visible: false },
    { id: 14, title: "Material Recovery Facility (MRF)", visible: false },
    { id: 15, title: "STP", visible: false },
    { id: 16, title: "Waste To Compost", visible: false },
    { id: 17, title: "Waste To Energy", visible: false },
    { id: 2, title: "Dump Site", visible: false },
    { id: 3, title: "Landfill", visible: false }
];
// AMRUT 2.0
const AMRUT_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/amrut_scheme/MapServer";
const AMRUT_SUBLAYERS = [
    { id: 1, title: "Green Space Development", visible: false },
    { id: 2, title: "Waterbody Rejuvenation", visible: false },

];
const GROUPS = [
    { url: BASE_SERVICE_URL, title: "Administrative Boundaries", sublayers: ADMIN_BOUNDARIES_SUBLAYERS },
    { url: ASSETS_URL1, title: "Government Assets", sublayers: ASSETS_Central_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Properties", sublayers: PROPERTY_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Green Spaces", sublayers: GREEN_SPACE_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Transportation", sublayers: TRANSPORTATION_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Waterbodies", sublayers: WATERBODIES_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Landmarks", sublayers: LANDMARKS_SUBLAYERS },
    { url: SBM_URL1, title: "SBM", sublayers: SBM_SUBLAYERS },
    { url: AMRUT_URL, title: "AMRUT 2.0", sublayers: AMRUT_SUBLAYERS },
    { url: MASTER_PLAN_URL, title: "Master Plan", sublayers: MASTER_PLAN_SUBLAYERS },
    { url: SAMPDA_GUIDELINE_URL, title: "Sampda Guideline", sublayers: SAMPDA_GUIDELINE_SUBLAYERS },
    { url: WATER_URL, title: "Water Supply Network", sublayers: WATER_SUBLAYERS },
    { url: SEWER_URL, title: "Sewerage Network", sublayers: SEWER_SUBLAYERS },
    { url: StormWaterURL, title: "Storm Water Network", sublayers: StormWaterURL_sublayer },
    { url: MPLanduse, title: "MP Landuse", sublayers: MPLanduse_sublayer },

];

//  layer End 

function IdentifiedProperty({ view }) {
    const dispatch = useDispatch()
    const { isTheme, isBufferWidth, isToolHeight } = useSelector((state) => state.currentStage)
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [districtCode, setDistrictCode] = useState("");
    const authData = useSelector(state => state.authToken.authData);
    const [ulbs, setUlbs] = useState([]);
    const [selectedUlb, setSelectedUlb] = useState("");
    const [ulbCode, setUlbCode] = useState("");
    const [refactive, setRefactive] = useState("0");
    const [wards, setWards] = useState([]);
    const [selectedWard, setSelectedWard] = useState("");
    const [wardCode, setWardCode] = useState("");
    const [active, setActive] = useState("total");
    const [activeSelect, setActiveSelect] = useState("area");
    const [isTableView, setIsTableView] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const [filteredPropertyData, setFilteredPropertyData] = useState([]);
    const [counts, setCounts] = useState({
        newCount: 0,
        surveyCount: 0,
        totalCount: 0,

    });

    const [expanded, setExpanded] = useState({});
    const [checked, setChecked] = useState({});
    const [search, setSearch] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);

    // State for PrimeReact DataTable
    const [columns, setColumns] = useState([]);
    const [first, setFirst] = useState(0); // Index of the first record
    const [rows, setRows] = useState(500); // Rows per page

    const [isPayload, setIsPayload] = useState();
    const [layerVisibility, setLayerVisibility] = useState({});
    const [expandedGroups, setExpandedGroups] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [mapLayers, setMapLayers] = useState({});
    const navigate = useNavigate();

    // code for layers
    const [layerGroups, setLayerGroups] = useState(GROUPS);



    const toggleLayer = (groupTitle, sublayerId) => {
        const updatedGroups = layerGroups.map(group => {
            if (group.title !== groupTitle) return group;

            const updatedSublayers = group.sublayers.map(sublayer =>
                sublayer.id === sublayerId
                    ? { ...sublayer, visible: !sublayer.visible }
                    : sublayer
            );

            return { ...group, sublayers: updatedSublayers };
        });

        setLayerGroups(updatedGroups);
    };

    const handleSublayerToggle = (groupKey, sublayer, checked) => {
        setLayerVisibility((prev) => ({
            ...prev,
            [`${groupKey}_${sublayer.id}`]: checked,
        }));

        // Toggle ArcGIS layer visibility
        const targetLayer = mapLayers[groupKey];
        if (targetLayer) {
            const subLayer = targetLayer.findSublayerById(sublayer.id);
            if (subLayer) subLayer.visible = checked;
        }

        // Build payload with full info
        const payload = {
            groupKey,
            groupName: GROUPS.find((g) => g.key === groupKey)?.title,
            checked,
            sublayer, // full object
        };

        setIsPayload(payload)

        console.log("Clicked:", payload);

        // Emit to parent if callback provided
        // if (onSublayerToggle) {
        //     onSublayerToggle(payload);
        // }
    };

    const toggleExpandGroup = (title) => {
        setExpandedGroups((prev) =>
            prev.includes(title)
                ? prev.filter((g) => g !== title)
                : [...prev, title]
        );
    };

    const filteredGroups = GROUPS.filter((group) => {
        const titleMatch = group.title
            .toLowerCase()
            .includes(searchTerm.toLowerCase());
        const subMatch = group.sublayers.some((s) =>
            s.title.toLowerCase().includes(searchTerm.toLowerCase())
        );
        return titleMatch || subMatch;
    });

    const handleTableView = () => {
        setIsTableView(!isTableView)
    }
    // code for server database connection by 
    const [data, setData] = useState([]);
    const [totalTax, setTotalTax] = useState(0);


    //app.get("/api/TaxAll", async (req, res) => { 
    const LoadTAX_DATA = ({ districtCode }) => {

        alert("selectedDistrict : ", districtCode);

        if (selectedWard && wardCode && ulbCode) {

            alert("wardCode : ", wardCode);
            LoadAPI();

        } else if (selectedUlb && ulbCode) {
            alert("selectedUlb : ", selectedUlb, ulbCode);
            LoadAPI();

        } else if (selectedDistrict && districtCode) {

            alert("selectedDistrict : ", districtCode);
            LoadAPI();
        }
        else {

            //LoadAPI();
        }

    };
    const LoadAPI = () => {

        fetch("https://www.urbangis.mp.gov.in/Taxall/api/TaxAll")
            .then(res => res.json())
            .then(rows => {
                console.log("Fetched:", rows);

                //alert("Fetched Data from server:", rows);
                setData(rows);

                // Save projected demand in state
                if (rows.length > 0) {
                    const demand = rows[0].projected_demand || 0;

                    const demand2 = formatAmount(demand);

                    setTotalTax(demand2);

                }
            })
            .catch(err => console.error("Error:", err));

    };




    const LoadAPI_distublward = ({ dist = "", ulb = "", ward = "" }) => {
        const params = new URLSearchParams();

        if (dist) params.append("dist", dist);
        if (ulb) params.append("ulb", ulb);
        if (ward) params.append("ward", ward);

        const url = `https://www.urbangis.mp.gov.in/Taxall/api/Taxdistublward?${params.toString()}`;

        console.log("Calling URL:", url);

        fetch(url)
            .then(res => res.json())
            .then(rows => {
                console.log("Fetched:", rows);

                if (rows.length > 0) {
                    const demand = rows[0].projected_demand || 0;

                    const demand2 = formatAmount(demand);

                    setTotalTax(demand2);
                }
            })
            .catch(err => console.error("Error:", err));
    };


    function formatAmount(value) {
        if (value >= 1e7) {
            return (value / 1e7).toFixed(2) + " Cr";       // 1 Crore = 1e7
        } else if (value >= 1e5) {
            return (value / 1e5).toFixed(2) + " Lakh";     // 1 Lakh = 1e5
        } else if (value >= 1e3) {
            return (value / 1e3).toFixed(2) + " Thousand"; // 1 Thousand = 1e3
        } else {
            return value.toFixed(2);                       // Less than 1000
        }
    }


    const stats = [
        { value: counts.totalCount, title: "Total Properties", subtitle: "No. of ULB 58" },
        { value: counts.surveyCount, title: "MPHS Surveyed Properties" },
        { value: counts.newCount, title: "New Identified properties", subtitle: "using urban analytics" },
        { value: totalTax, title: "Appx.Estimated Revenue Potential. ", subtitle: "using urban analytics" },
        { value: '-', title: "Registered on ENP 2.0 ", subtitle: "using urban analytics" },

        //new properties registered on ENP 2.0 

    ];

    const toggleExpand = (layer) => {
        setExpanded((prev) => ({ ...prev, [layer]: !prev[layer] }));
    };

    const toggleCheck = (layer) => {
        setChecked((prev) => ({ ...prev, [layer]: !prev[layer] }));
    };

    const filteredLayers = layersData.filter((layer) =>
        layer.toLowerCase().includes(search.toLowerCase())
    );

    // All dropdown loading functions (loadDistricts, loadUlbs, loadWards) remain unchanged.
    useEffect(() => {
        const loadDistricts = async () => {
            const url = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";
            try {
                const response = await fetch(url);
                const data = await response.json();
                LoadAPI();
                if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
                    const userDistrict = [{
                        districtName: authData.DistrictName,
                        districtCode: authData.DistrictCode,
                    }];
                    setDistricts(userDistrict);
                    setDistrictCode(authData.DistrictCode);
                    setSelectedDistrict(authData.DistrictName);
                    await loadUlbs(authData.DistrictCode);
                } else {
                    const formatted = data.features.map(f => ({
                        districtName: f.properties.districtname,
                        districtCode: f.properties.dist_cd,
                    }));
                    setDistricts(formatted);

                }
            } catch (err) {
                console.error("Error loading districts:", err);
            }
        };

        loadDistricts();
    }, [authData]);

    const loadUlbs = async (dist_cd) => {

        //         alert("LoadAPI_distublward  dist_cd "+dist_cd);


        // LoadAPI_distublward({ dist: dist_cd });

        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            if (authData?.UserType === "User") {
                const formattedUlbs = [{
                    ulbName: authData?.UlbName,
                    ulbCode: authData?.Ulb_Code,
                }];
                setUlbs(formattedUlbs);
                setUlbCode(authData?.Ulb_Code);
                setSelectedUlb(authData?.UlbName);
                await loadWards(authData?.Ulb_Code);
            } else if (data.features) {
                const formattedUlbs = data.features.map(f => ({
                    ulbName: f.properties.name,
                    ulbCode: f.properties.ulb_cd,
                }));
                setUlbs(formattedUlbs);
            }
        } catch (err) {
            console.error("Error loading ULBs:", err);
        }
    };

    const loadWards = async (ulb_cd) => {

        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/7/query?where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            const formatted = data.features.map(f => ({
                wardName: f.properties.wardname,
                wardCode: f.properties.wardno,
                displayLabel: `${f.properties.wardno} - ${f.properties.wardname}`
            }));
            setWards(formatted);
        } catch (err) {
            console.error("Error loading wards:", err);
        }
    };

    const handleDistrictChange = async (selectedOption) => {
        if (!selectedOption) {
            handleRefresh();
            return;
        }
        const district = districts.find(d => d.districtCode === selectedOption.value);
        if (district) {
            setDistrictCode(district.districtCode);
            setSelectedDistrict(district.districtName);
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            await loadUlbs(district.districtCode);

            fetchAndZoomPropertyChanges({ dist_cd: district.districtCode });
            //  alert("handle District Change "+district.districtCode);

            LoadAPI_distublward({ dist: district.districtCode });
        }
    };

    const handleUlbChange = async (selectedOption) => {
        if (!selectedOption) {
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            fetchAndZoomPropertyChanges({ dist_cd: districtCode }); // Refetch for the district
            return;
        }
        const ulb = ulbs.find(u => u.ulbCode === selectedOption.value);
        if (ulb) {
            setUlbCode(ulb.ulbCode); setSelectedUlb(ulb.ulbName); setWardCode(""); setSelectedWard("");
            await loadWards(ulb.ulbCode);
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulb.ulbCode });
            //  alert("handleUlbChange "+ ulb.ulbCode);

            // const LoadAPI_distublward = ({ dist = "", ulb = "", ward = "" }) 
            LoadAPI_distublward({ dist: districtCode, ulb: ulb.ulbCode });
        }
    };

    const handleWardChange = async (selectedOption) => {
        if (!selectedOption) {
            setWardCode(""); setSelectedWard("");
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode }); // Refetch for the ULB
            return;
        }
        const ward = wards.find(w => w.wardCode === selectedOption.value);
        if (ward) {
            setWardCode(ward.wardCode);
            setSelectedWard(ward.wardName);
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: ward.wardCode });
            // alert("handleWardChange "+ward.wardCode);

            LoadAPI_distublward({ dist: districtCode, ulb: ulbCode, ward: ward.wardCode });

        }
    };

    // fetchCountByRemarks and other logic functions remain the same

    // bhupen code for enp cout type 





    const fetchCountByRemarks = async ({ dist_cd, ulb_cd, wardno, remarks }) => {
       
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/property_change_detection/MapServer/14/query";
        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`,
            ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`,
            remarks && `remarks='${remarks}'`
        ].filter(Boolean);
        const where = whereParts.length > 0 ? whereParts.join(" AND ") : "1=1";
        const outStatistics = [{ statisticType: "count", onStatisticField: "objectid", outStatisticFieldName: "total_count" }];
        const params = new URLSearchParams({ where, outStatistics: JSON.stringify(outStatistics), f: "json" });
        const url = `${baseUrl}?${params.toString()}`;
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const json = await response.json();
            return json.features?.[0]?.attributes?.total_count || 0;
        } catch (err) {
            console.error(`Error fetching count:`, err);
            return 0;
        }
    };

    useEffect(() => {
        const initLoad = async () => {
            setIsLoading(true);
            const filters = (authData?.UserType === "districtuser" || authData?.UserType === "User")
                ? { dist_cd: authData.DistrictCode, ulb_cd: authData.Ulb_Code, wardno: wardCode }
                : {};
            await fetchAllCounts(filters);


            await fetchPropertyData({ ...filters, page: 1 });
            setIsLoading(false);
        };
        if (authData) initLoad();
    }, [authData, rows]); // Re-run if `rows` changes

    const fetchAllCounts = async ({ dist_cd, ulb_cd, wardno }) => {



        const [newCount, surveyCount, totalCount] = await Promise.all([
            fetchCountByRemarks({ dist_cd, ulb_cd, wardno, remarks: "New" }),
            fetchCountByRemarks({ dist_cd, ulb_cd, wardno, remarks: "Surveyed" }),
            fetchCountByRemarks({ dist_cd, ulb_cd, wardno }),


        ]);
        setCounts({ newCount, surveyCount, totalCount });


    };

    const generateTableHeaders = (data) => {
        if (!data || data.length === 0) return [];
        const excludedKeys = ["Statecode", "objectid", "Zoneno", "Ulbname", "ulbtype", "photograph_id", "Taxratezone", "ulbname", "Districtname", "Globalid", "dist_cd", "districtcode", "div_cd", "divisioncode", "Uaddgislab_sde_property_change_area", "ulb_cd", "ulbcode", "singlepage_id", "slumornonslum", "st_length(shape)", "st_area(shape)", "created_user", "last_edited_date", "last_edited_user", 'created_date',];
        const excludedKeysLower = excludedKeys.map(key => key.toLowerCase());
        const keys = Object.keys(data[0]).filter(key => !excludedKeysLower.includes(key.toLowerCase()));
        return keys.map(key => ({
            field: key,
            header: key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()).replace(/_/g, " "),
        }));
    };

    // UPDATED data fetching function for PrimeReact
    const fetchPropertyData = async ({ dist_cd, ulb_cd, wardno, filterType = active, page = 1 }) => {
        setIsTableLoading(true);
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/property_change_detection/MapServer/14/query";
        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`,
            ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`,
            filterType && filterType !== "total" && `remarks='${filterType}'`
        ].filter(Boolean);
        const where = whereParts.length > 0 ? whereParts.join(" AND ") : "1=1";

        const pageSize = rows;
        const offset = pageSize * (page - 1);

        const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=false&f=json&resultOffset=${offset}&resultRecordCount=${pageSize}`;

        try {
            const response = await fetch(url);
            const json = await response.json();
            const properties = json.features.map(f => f.attributes);

            if (properties.length > 0) {
                setColumns(generateTableHeaders(properties));
            } else {
                setColumns([]);
            }

            setFilteredPropertyData(properties);
            setCurrentPage(page);
            setFirst(offset);

            // Fetch total count separately for pagination to be accurate
            const totalCountResponse = await fetchCountByRemarks({ dist_cd, ulb_cd, wardno, remarks: filterType !== "total" ? filterType : null });
            setTotalRecords(totalCountResponse);

        } catch (err) {
            console.error("Error fetching property data:", err);
        } finally {
            setIsTableLoading(false);
        }
    };

    // NEW event handlers for PrimeReact Paginator
    const onPageChangePrimeReact = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        const newPage = Math.floor(event.first / event.rows) + 1;
        fetchPropertyData({
            dist_cd: districtCode,
            ulb_cd: ulbCode,
            wardno: wardCode,
            filterType: active,
            page: newPage
        });
    };

    const onRowsChangePrimeReact = (newRows) => {
        setFirst(0);
        setRows(newRows);
        fetchPropertyData({
            dist_cd: districtCode,
            ulb_cd: ulbCode,
            wardno: wardCode,
            filterType: active,
            page: 1
        });
    };
    const filterProperties = (filterType) => {
        setActive(filterType);
        setCurrentPage(1);
        setFirst(0); // Reset paginator to the first page
        fetchPropertyData({
            dist_cd: districtCode,
            ulb_cd: ulbCode,
            wardno: wardCode,
            filterType: filterType,
            page: 1
        });
    };

    // fetchAndZoomPropertyChanges and other helpers remain the same
    const fetchAndZoomPropertyChanges = async ({ dist_cd, ulb_cd, wardno }) => {
        setIsLoading(true);
        await fetchAllCounts({ dist_cd, ulb_cd, wardno });
        await fetchPropertyData({ dist_cd, ulb_cd, wardno, page: 1 });
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/property_change_detection/MapServer/14/query";
        const where = [dist_cd && `dist_cd='${dist_cd}'`, ulb_cd && `ulb_cd='${ulb_cd}'`, wardno && `wardno='${wardno}'`].filter(Boolean).join(" AND ") || "1=1";
        const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=true&f=json`;
        try {
            const response = await fetch(url);
            const json = await response.json();
            const graphics = json.features.map(f => new Graphic({
                geometry: { type: "polygon", rings: f.geometry.rings, spatialReference: { wkid: 102100 } },
                symbol: { type: "simple-fill", color: [255, 0, 0, 0.4], outline: { color: [255, 0, 0], width: 1 } },
                attributes: f.attributes
            }));
            if (graphics.length && view) {
                view.graphics.removeAll(); // Clear previous graphics
                view.graphics.addMany(graphics);
                await view.goTo(graphics);
            }
        } catch (err) {
            console.error("Error fetching property change data:", err);
        } finally {
            setIsLoading(false);
        }
    };





    const dataChart = [
        ["Category", "Properties"],
        // ["Total Properties", counts.totalCount],
        ["Surveyed Properties", counts.surveyCount],
        ["New Properties", counts.newCount],
    ];

    const chartOptions = {
        title: "Property Statistics",
        backgroundColor: "transparent",
        pieHole: 0.4, // Creates a Donut Chart. Does not do anything when is3D is enabled
        is3D: true, // 
        legend: {
            position: "right",
            textStyle: { color: isTheme === "dark" ? "white" : "black" },
        },
        titleTextStyle: {
            color: isTheme === "dark" ? "white" : "black",
            fontSize: 16,
        },
        // colors: ["#", "#55ff00", "#fa709a"],
        colors: ["#55ff00", "#ff0000", "#fa709a"],
        sliceVisibilityThreshold: 0, // ✅ ensures small values are shown
    };


    const PaginationControls = ({
        currentPage,
        totalRecords,
        pageSize,
        onPageChange,
        isLoading
    }) => {
        const totalPages = Math.ceil(totalRecords / pageSize);

        // Show pagination even if there's only one page, but disable navigation
        return (
            <div className="pagination-controls d-flex align-items-center">
                <button
                    className="btn btn-sm btn-outline-primary me-2"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1 || isLoading}
                >
                    &lt;
                </button>

                <span className="mx-2">
                    Page {currentPage} of {totalPages}
                    <small className="text-muted ms-2">
                        (Records {((currentPage - 1) * pageSize) + 1} - {Math.min(currentPage * pageSize, totalRecords)} of {totalRecords})
                    </small>
                </span>

                <button
                    className="btn btn-sm btn-outline-primary ms-2"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages || isLoading}
                >
                    &gt;
                </button>

                <div className="ms-3 text-muted">
                    <small>{pageSize} records per page</small>
                </div>
            </div>
        );
    };

    const handleLoadMore = async () => {
        // setIsLoadingMore(true);
        const nextPage = currentPage + 1;

        const newData = await fetchPropertyData({
            dist_cd: districtCode,
            ulb_cd: ulbCode,
            wardno: wardCode,
            filterType: active,
            page: nextPage
        });

        // Append new data to existing data (for infinite scroll)
        setFilteredPropertyData(prevData => [...prevData, ...newData]);
        setCurrentPage(nextPage);
    };

    const handleGetData = (item) => {
        if (item.title === "Total Properties") {
            filterProperties("total");
            setActive("total");
            setRefactive("0");
        } else if (item.title === "MPHS Surveyed Properties") {
            filterProperties("Surveyed");
            setActive("Surveyed");
            setRefactive("0");
        } else if (item.title === "New Identified properties") {
            filterProperties("New");
            setActive("New");
            setRefactive("0");
        }
    }

    const downloadExcel = () => {
        if (filteredPropertyData.length === 0) {
            alert("No data available to download");
            return;
        }

        // Generate headers
        const headers = generateTableHeaders(filteredPropertyData);

        // Prepare data for Excel
        const excelData = filteredPropertyData.map(row => {
            const obj = {};
            headers.forEach(header => {
                obj[header.header] = row[header.field] !== undefined ? row[header.field] : "-";
            });
            return obj;
        });

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Property Data");

        // Generate Excel file
        const fileName = `Property_Data_${selectedDistrict || 'All'}_${selectedUlb || 'All'}_${selectedWard || 'All'}_${new Date().toISOString().split('T')[0]}.xlsx`;

        // Download the file
        XLSX.writeFile(wb, fileName);
    };

    const handleRefresh = async () => {
        // First reset all state
        setUlbs([]);
        setSelectedDistrict("");
        setDistrictCode("");
        setUlbCode('');
        setSelectedUlb('');
        setWardCode('');
        setWards([]);
        setWardCode("");
        setSelectedWard("");
        setRefactive("1");
        setActive("total")

        // Dispatch reset actions if needed
        dispatch(setIsDist(""));
        dispatch(setIsUlb(""));
        dispatch(setIsWard(""));

        await fetchAllCounts({});
        await fetchPropertyData({});

        // Then perform view operations
        if (view) {
            try {
                // Remove all graphics
                view.graphics.removeAll();

                // Go to initial view
                view.goTo({
                    target: [78.746567, 23.83403], // Using 'target' instead of 'center'
                    zoom: 7
                }).catch(error => {
                    console.error("Error during goTo:", error);
                });
            } catch (error) {
                console.error("Error during refresh:", error);
            }
        } else {
            console.warn("View is not available");
        }
    };

    const formatNumberWithCommas = (value) => {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'string') {
            if (value.includes('/')) {
                const parts = value.split('/');
                if (parts.length === 2) {
                    const numerator = formatNumberWithCommas(parts[0]);
                    const denominator = formatNumberWithCommas(parts[1]);
                    return `${numerator}/${denominator}`;
                }
            }
            const numericMatch = value.match(/([-\d,.]+)(.*)/);
            if (numericMatch) {
                const numericPart = numericMatch[1].replace(/,/g, '');
                const unitPart = numericMatch[2];
                if (!isNaN(numericPart)) {
                    const num = Number(numericPart);
                    const formattedNumber = num.toLocaleString('en-IN');
                    return `${formattedNumber}${unitPart}`;
                }
            }
            return value;
        }
        if (typeof value === 'number') {
            return value.toLocaleString('en-IN');
        }
        return value;
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
            borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
            "&:hover": {
                borderColor: "#ccc",
            },
            fontSize: "12px",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#d1ede9"
                : state.isFocused
                    ? "#d1ede9"
                    : "#FFFFFF",
            color: "#000",
            fontSize: "12px",
            padding: "10px",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#000",
            fontSize: "12px",
        }),
        input: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
    };



    return (
        <div style={{ border: "none", height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)' }} className='px-2'>
            {/* The top part of your component (Map and Filters) remains unchanged */}
            <div className={isTableView ? 'd-none' : ''}>
                <div className='row' >
                    <div className={isBufferWidth ? 'col-md-12 p-0' : "col-md-9 p-0"}>
                        <MapNewProperty
                            isLayerInfo={isPayload}
                            groups={layerGroups}

                            selectedDistrict={selectedDistrict} selectedUlb={selectedUlb} selectedWard={selectedWard} districtCode={districtCode}
                            ulbCode={ulbCode} wardCode={wardCode} activeTabinfo={active} activeTabRef={refactive} dist_cd={districtCode} ulb_cd={ulbCode} wardno={wardCode}
                        />
                    </div>
                    {!isBufferWidth && (
                        <div className='col-md-3 p-0'>
                            <div className='px-2'>
                                <div className='tooltitlediv linear-gradian-bg d-flex justify-content-between align-items-center px-3'>
                                    <h6 className='sidebarbuttontitle text-white m-0'>Identified New Property</h6>
                                    {/* <button className='btn text-white no-hover'
                                        onClick={() => navigate("/link-dashboard")}
                                    >Back</button> */}
                                </div>

                                <div className="tabs-container d-flex justify-content-between mt-3">
                                    <button className={`tab-btn ${activeSelect === "area" ? "active" : ""}`} onClick={() => setActiveSelect("area")}>Select Area</button>
                                    <button className={`tab-btn ${activeSelect === "layer" ? "active" : ""}`} onClick={() => setActiveSelect("layer")} >Layer</button>
                                </div>
                                <div className={isToolHeight ? 'scroll-layerdiv' : 'scroll-layerdivheight '}>
                                    {activeSelect === "area" ?
                                        <>
                                            <div className="mt-2">
                                                <label className="lebel-card-text">Select District</label>
                                                <Select
                                                    options={districts.map((d) => ({ value: d.districtCode, label: d.districtName })).sort((a, b) => a.label.localeCompare(b.label))}
                                                    value={districtCode ? { value: districtCode, label: selectedDistrict } : null}
                                                    onChange={(selectedOption) => !selectedOption ? handleRefresh() : handleDistrictChange(selectedOption)}
                                                    styles={customStyles} placeholder="Select District" isClearable={true}
                                                    isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User"}
                                                />
                                            </div>
                                            <div className="mt-2">
                                                <label className="lebel-card-text">Select ULB</label>
                                                <Select
                                                    options={ulbs.map((u) => ({ value: u.ulbCode, label: u.ulbName })).sort((a, b) => a.label.localeCompare(b.label))}
                                                    value={ulbCode ? { value: ulbCode, label: selectedUlb } : null}
                                                    onChange={handleUlbChange} placeholder="Select ULB" isClearable={true}
                                                    isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User" || !districtCode} styles={customStyles}
                                                />
                                            </div>
                                            <div className="mt-2">
                                                <label className="lebel-card-text">Select ward</label>
                                                <Select
                                                    options={wards.map((w) => ({ value: w.wardCode, label: w.displayLabel })).sort((a, b) => Number(a.value) - Number(b.value))}
                                                    value={wardCode ? { value: wardCode, label: wards.find(w => w.wardCode === wardCode)?.displayLabel } : null}
                                                    onChange={handleWardChange} placeholder="Select ward" isClearable={true} isDisabled={!ulbCode} styles={customStyles}
                                                />
                                            </div>
                                            <Chart
                                                chartType="PieChart"
                                                width="100%"
                                                height="300px"
                                                data={dataChart}
                                                options={chartOptions}
                                            />
                                        </>
                                        :
                                        <LayerControlPanel groups={layerGroups} toggleLayer={toggleLayer} />

                                    }
                                    {!(authData?.UserType === "districtuser" || authData?.UserType === "User") &&
                                        <button className="btn-refresh2" onClick={handleRefresh} style={{ marginTop: "14px" }}>
                                            <img src={isTheme === 'light' ? "img/refreshlight.svg" : "img/refresh.svg"} alt="refresh" width="20px" height="20px" /> Refresh
                                        </button>
                                    }

                                </div>

                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className='px-2'>
                <div className='row '>
                    {!isTableView && (
                        <div className='col-md-5'>
                            <div className="row" style={{ rowGap: "15px" }}>
                                {stats.map((s, idx) => (
                                    <div className="col-md-4" key={idx} onClick={() => handleGetData(s)}>
                                        <div className={`property-tax-in-${idx} text-center ev-card-div-${idx} px-2 py-2`}>
                                            <h3 className={`m-0 property-card-id-titlein tax-property-h3-${idx}`}>{formatNumberWithCommas(s.value)}</h3>
                                            <p className={`property-card-id-text-in m-0 tax-property-h3-${idx}`}>{s.title}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className={isTableView ? 'col-md-12 mt-3' : 'col-md-7'}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="tabs-container">
                                <button className={`tab-btn ${active === "total" ? "active" : ""}`} onClick={() => filterProperties("total")}>Total Property</button>
                                <button className={`tab-btn ${active === "Surveyed" ? "active" : ""}`} onClick={() => filterProperties("Surveyed")}>Surveyed</button>
                                <button className={`tab-btn ${active === "New" ? "active" : ""}`} onClick={() => filterProperties("New")}>New Properties</button>
                            </div>
                            <div className='d-flex gap-3'>
                                {ulbCode && <button className='gradient-btn' onClick={downloadExcel}><img src="img/gradiant-download.svg" alt='download' /> Download Data</button>}
                                <button onClick={handleTableView} className='btn p-0 btn-titles btn-titlesdiv'><img src="img/expand-icon.svg" alt='Maximise Panel' />{isTableView ? 'Minimise' : "Maximise"} Table</button>
                            </div>
                        </div>

                        {/* REPLACEMENT: PrimeReact DataTable and Paginator */}
                        <div className='identified-property-table-wrapper mt-2 relative table-indentify'
                        >
                            <DataTable
                                value={filteredPropertyData}
                                scrollable
                                scrollHeight={
                                    isTableView
                                        ? (isToolHeight ? "calc(100vh - 215px)" : "calc(100vh - 310px)")
                                        : (isToolHeight ? "135px" : "135px")
                                }
                                // scrollHeight={isTableView ? 'calc(100vh - 215px)' : !isToolHeight ? 'calc(100vh - 310px)' : '135px'}
                                style={{ minWidth: '10rem', width: '100%' }}
                                loading={isTableLoading}
                                emptyMessage="No data found"
                                resizableColumns
                                columnResizeMode="expand"
                            >
                                {!isTableLoading && (
                                    <Column
                                        field="index"
                                        header="S.No"
                                        body={(data, options) => first + options.rowIndex + 1}
                                        headerStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        bodyStyle={{ textAlign: 'center', justifyContent: 'center' }}

                                    />
                                )}
                                {columns.map((col) => (
                                    <Column
                                        key={col.field}
                                        field={col.field}
                                        header={col.header}
                                        sortable
                                        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }}
                                        headerStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        bodyStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        body={(rowData) => (<span title={rowData[col.field]} className='text-center' style={{ display: 'block', width: '100%' }}>{rowData[col.field]}</span>)}
                                    />
                                ))}
                            </DataTable>

                            {totalRecords > 0 && (
                                <div className="fixed-pagination custome-pagination">
                                    <Paginator
                                        first={first}
                                        rows={rows}
                                        totalRecords={totalRecords}
                                        rowsPerPageOptions={[100, 200, 500, 2000]}
                                        onPageChange={onPageChangePrimeReact}
                                        template={{
                                            layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
                                            RowsPerPageDropdown: (options) => {
                                                const dropdownOptions = [
                                                    { label: 100, value: 100 },
                                                    { label: 200, value: 200 }, { label: 500, value: 500 }, { label: 2000, value: 2000 }
                                                ];
                                                return (
                                                    <React.Fragment>
                                                        {/* <span className="p-mx-3" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Items per page: </span> */}
                                                        <select value={rows} onChange={(e) => onRowsChangePrimeReact(Number(e.target.value))}
                                                            style={{ padding: '0', borderRadius: '3px', border: '1px solid #ced4da' }}>
                                                            {dropdownOptions.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
                                                        </select>
                                                    </React.Fragment>
                                                );
                                            }
                                        }}
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                        style={{ position: 'sticky', bottom: 0, backgroundColor: '#e6fffa', padding: '0.5rem', borderTop: '1px solid #dee2e6', zIndex: 10 }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IdentifiedProperty
